import { withDefaults } from '@warp-drive/legacy/model/migration-support';

const PcsProviderSchema = withDefaults({
  type: 'pcs-provider',
  fields: [
    {
      kind: 'attribute',
      name: 'description',
    },
    {
      kind: 'attribute',
      name: 'metadata',
    },
    {
      kind: 'hasMany',
      name: 'pcsCompanies',
      type: 'pcs-company',
      options: {
        async: false,
        inverse: 'pcsProvider',
      },
    },
    {
      kind: 'hasMany',
      name: 'pcsCards',
      type: 'pcs-card',
      options: {
        async: false,
        inverse: 'pcsProvider',
      },
    },
  ],
});

export default PcsProviderSchema;
